import {
  appendCsTicketMessage,
  clearActiveRedesignRequest,
  closeMessengerWithSearchParams,
  linkTo,
  loadNextMessagePage,
  openMessengerWithSearchParams,
  resendMessage,
  selectSpace,
  sendMessage,
  submitMultiSelect,
  updateMessage
} from './actions';

import { updateMessageInLocalStorage } from 'shared/components/Messenger/hooks/useSavedMessage';

import { emitUpdateZendeskHelpPosition } from 'web-services/chat';

import * as consts from './consts';

/**
 * To support the same style of structure as coming from the NextJS app
 * we need to wrap the regular redux dispatch with some middleware
 *
 * This middleware captures action events and dispatches them using the thunk
 * middleware already applied to the store
 */
export const applyActionMiddleware = (dispatch) => ({ type, payload }) => {
  switch (type) {
    case consts.MESSENGER_ACTION_DESIGN_RATED: {
      dispatch(updateMessage({ type, payload }));
      break;
    }
    case consts.MESSENGER_ACTION_IMAGE_TEXT_CARD_SELECTED: {
      dispatch(linkTo(payload.value));
      break;
    }
    case consts.MESSENGER_SUBMITTED_MULTI_SELECT: {
      dispatch(updateMessage({ type, payload }));
      dispatch(submitMultiSelect());
      break;
    }
    case consts.MESSENGER_RESEND_MESSAGE: {
      dispatch(resendMessage(payload));
      break;
    }
    case consts.MESSENGER_APPEND_CS_TICKET_MESSAGE: {
      dispatch(appendCsTicketMessage(payload));
      break;
    }
    case consts.MESSENGER_SEND_MESSAGE: {
      dispatch(sendMessage(payload));
      dispatch(updateMessageInLocalStorage({ message: '', isRichText: false }));
      break;
    }
    case consts.MESSENGER_REVISION_CLICKED:
    case consts.MESSENGER_START_REDESIGN: {
      dispatch(sendMessage({ isRedesign: true }));
      break;
    }
    case consts.MESSENGER_LOAD_ADDITIONAL_MESSAGES: {
      dispatch(loadNextMessagePage(payload));
      break;
    }
    case consts.MESSENGER_SELECTED_SPACE_CHANGE: {
      dispatch(selectSpace({ spaceId: payload }));
      break;
    }
    case consts.MESSENGER_ACTION_CANCEL_CLICKED: {
      dispatch(clearActiveRedesignRequest());
      break;
    }
    case consts.MESSENGER_ACTION_UPDATE_MESSAGE: {
      dispatch(updateMessage({ type, payload }));
      break;
    }
    case consts.MESSENGER_ACTION_IMAGE_SELECTED: {
      if (payload.actionType === 'link') {
        dispatch(linkTo(payload.selection.value));
      } else {
        dispatch(updateMessage({ type, payload }));
      }
      break;
    }
    case consts.MESSENGER_ACTION_SAVE_DRAFT_STATE: {
      dispatch(updateMessageInLocalStorage({ message: JSON.stringify(payload), isRichText: true }));
      break;
    }

    case consts.OPEN_MESSENGER: {
      emitUpdateZendeskHelpPosition();
      dispatch(openMessengerWithSearchParams());
      break;
    }

    case consts.MESSENGER_LOCAL_TEXT_CHANGED: {
      dispatch(updateMessageInLocalStorage({ message: payload.messageText, isRichText: false }));
      dispatch({ type, payload });
      break;
    }

    case consts.MESSENGER_TEXT_CHANGED: {
      dispatch(updateMessageInLocalStorage({ message: payload.messageText, isRichText: false }));
      dispatch({ type, payload });
      break;
    }

    case consts.MESSENGER_X_OUT_CLICKED: {
      emitUpdateZendeskHelpPosition();
      closeMessengerWithSearchParams();
      break;
    }

    default: {
      dispatch({ type, payload });
      break;
    }
  }
};
